import axios from 'axios';

import * as classroomActions from './classroomActions';
import { isFetching } from '../componentActions';
import { setClassroomGroups } from './classroomActions';
import { GROUPS, PICTOGRAM_CONFIG } from '../../const';
import * as classroomApi from '../../services/api/classroomApi';
import * as groupApi from '../../services/api/groupApi';
import { API_GROUPS, API_USERS, API_GROUPS_PICTOGRAMS, API_CLASSROOMS_GROUPS } from '../../services/api/apiConst';
import { PARAMS } from '../../const';
import { REDUCER } from '../../reducers/reducersConst';
import { I18n } from 'react-redux-i18n-lite';
import * as presenceApi from '../../services/api/presenceApi';
import { getUpdatedParticipantsPresenceWithAPI } from '../../services/presence/presenceService';
import { setFetchingParticipants } from './classroomActions';
import { ANALYTICS_CONTEXT } from '../../types/analytics';

export const setSelectedGroup = (group = {}) => {
  return {
    type: REDUCER.SEL_GROUP.SET_SELECTED_GROUP,
    group
  };
};

export const setAddGroupIsOpen = (addGroupIsOpen = false) => {
  return {
    type: REDUCER.GROUP.SET_ADD_GROUP_IS_OPEN,
    addGroupIsOpen
  };
};

export const setGroupToRemove = (groupToRemove = null) => {
  return {
    type: REDUCER.GROUP.SET_GROUP_TO_REMOVE,
    groupToRemove
  };
};

export const setPictogramConfig = (pictogramConfigGroup = null) => {
  return {
    type: REDUCER.GROUP.SET_PICTOGRAM_CONFIG,
    pictogramConfigGroup
  };
};

export const getClassroomGroups = (classroomId = '') => {
  return (dispatch, getState) => {
    if (classroomId) {
      return classroomApi.getGroups(classroomId).then(res => {
        let everyone = {
          id: GROUPS.EVERYONE.id,
          name: I18n.t('lessonCard.everyone'),
          defaultGroup: true,
          participants: []
        };
        const groups = [everyone].concat(res.data);
        dispatch(setClassroomGroups(groups));
        const storedParticipants = getState().classrooms.selectedClassroom.participants;
        const participants = addGroupsToStudents(groups, storedParticipants);
        dispatch(classroomActions.setClassroomParticipants(participants));
      });
    }
  };
};

export const getParticipantsWithStatus = classroomId => {
  return (dispatch, getState) => {
    dispatch(setFetchingParticipants(true));
    return classroomApi.getClassroomParticipants(classroomId).then(res => {
      const groups = getState().classrooms.selectedClassroom.groups;
      const schoolId = getState().school.school.id;
      const participants = addGroupsToStudents(groups, res.data);

      // Publicar inmediatamente la lista básica de participantes antes de recuperar presencias
      dispatch(classroomActions.setClassroomParticipants(participants));
      dispatch(setFetchingParticipants(false));

      presenceApi
        .getClassroomPresence(classroomId, schoolId)
        .then(out => {
          const connected = out.data;
          const updatedParticipantsPresence = getUpdatedParticipantsPresenceWithAPI(participants, connected);
          dispatch(classroomActions.setClassroomParticipants(updatedParticipantsPresence));
          dispatch(setFetchingParticipants());
        })
        .catch(() => {
          dispatch(classroomActions.setClassroomParticipants(participants));
          dispatch(setFetchingParticipants());
        });
    });
  };
};

export const getStudentsFromGroup = classroomId => {
  return dispatch => {
    if (classroomId) {
      return dispatch(getParticipantsWithStatus(classroomId));
    }
  };
};

export const assignStudentToGroup = (userId = '', groupId = '', classroom = {}) => {
  return dispatch => {
    if (userId && groupId && classroom.sectionId) {
      return axios
        .post(`${API_USERS}/${userId}/group`, {
          sectionId: classroom.sectionId,
          groupId: groupId,
          doAssign: true
        })
        .then(() => {
          dispatch(getClassroomGroups(classroom.id));
        });
    }
  };
};

export const removeStudentFromGroup = (userId = '', groupId = '', classroom = {}) => {
  return dispatch => {
    if (userId && groupId && classroom.sectionId) {
      return axios
        .post(`${API_USERS}/${userId}/group`, {
          sectionId: classroom.sectionId,
          groupId: groupId,
          doAssign: false
        })
        .then(() => {
          dispatch(getClassroomGroups(classroom.id)).then(() => {
            dispatch(getStudentsFromGroup(classroom.id, groupId));
          });
        });
    }
  };
};

export const addGroup = (groupName = '') => {
  return (dispatch, getState) => {
    const state = getState();
    const userId = state.account.user._id;
    const classroom = state.classrooms.selectedClassroom.classroom;
    const sectionId = classroom.sectionId;
    if (userId && sectionId && groupName) {
      dispatch(isFetching(true));
      const url = API_CLASSROOMS_GROUPS.replace(PARAMS.CLASSROOM, classroom.id);
      return axios
        .post(url, {
          sectionId: sectionId,
          userId: userId,
          name: groupName,
          pictogramConfig: PICTOGRAM_CONFIG.IMAGE,
          context: ANALYTICS_CONTEXT.GROUP_CREATE
        })
        .then(group => {
          dispatch(getClassroomGroups(classroom.id));
          dispatch(isFetching(false));
        })
        .catch(() => {
          dispatch(isFetching(false));
        });
    }
  };
};

export const removeGroup = (groupId = '') => {
  return (dispatch, getState) => {
    if (groupId) {
      const classroomId = getState().classrooms.selectedClassroom.classroom.id;
      return axios.delete(`${API_GROUPS}/${groupId}`).then(res => {
        dispatch(getClassroomGroups(classroomId));
        dispatch(classroomActions.getClassroomParticipants(classroomId));
        return res;
      });
    }
  };
};

export const setPictogramConfigGroup = (groupId = '', pictogramConfig = '') => {
  return (dispatch, getState) => {
    if (groupId && pictogramConfig) {
      const classroomId = getState().classrooms.selectedClassroom.classroom.id;
      return axios.put(`${API_GROUPS_PICTOGRAMS}`, { groupId: groupId, pictogramConfig: pictogramConfig }).then(res => {
        dispatch(getClassroomGroups(classroomId));
        dispatch(classroomActions.getClassroomParticipants(classroomId));
        return res;
      });
    }
  };
};

export const editGroup = (groupId = '', newName = '') => {
  return (dispatch, getState) => {
    if (groupId && newName) {
      const classroomId = getState().classrooms.selectedClassroom.classroom.id;
      return groupApi.editGroup(groupId, newName, classroomId).then(res => {
        dispatch(getClassroomGroups(classroomId));
        dispatch(classroomActions.getClassroomParticipants(classroomId));
        
        // Actualizar el grupo seleccionado con el nuevo nombre
        const state = getState();
        const currentGroup = state.selectedGroup.group;
        if (currentGroup.id === groupId) {
          const updatedGroup = { ...currentGroup, name: newName };
          dispatch(setSelectedGroup(updatedGroup));
        }
        
        return res;
      }).catch(error => {
        console.error('Error editing group:', error);
        throw error;
      });
    }
  };
};

export const setEditGroupIsOpen = (isOpen = false) => {
  return {
    type: REDUCER.GROUP.SET_EDIT_GROUP_IS_OPEN,
    isOpen
  };
};

export const setGroupToEdit = (group = null) => {
  return {
    type: REDUCER.GROUP.SET_GROUP_TO_EDIT,
    group
  };
};

const addGroupsToStudents = (groups, participants) => {
  const updatedParticipants = [];

  if (!groups) {
    return (participants || []).map(participant => Object.assign({}, participant));
  }

  if (groups) {
    const userGroups = getUserGroups(groups);

    participants.map(participant => {
      participant.groups = userGroups[participant._id];
      updatedParticipants.push(Object.assign({}, participant));
    });
  }
  return updatedParticipants;
};

const getUserGroups = groups => {
  const userGroups = {};
  for (let group = 0; group < groups.length; group++) {
    for (
      let participant = 0;
      groups[group].participants && participant < groups[group].participants.length;
      participant++
    ) {
      userGroups[groups[group].participants[participant]] = userGroups[groups[group].participants[participant]] || [];
      let newUserGroup = {};
      newUserGroup.id = groups[group].id;
      newUserGroup.name = groups[group].name;
      newUserGroup.colour = groups[group].colour;
      newUserGroup.defaultGroup = groups[group].defaultGroup;
      userGroups[groups[group].participants[participant]].push(newUserGroup);
    }
  }

  return userGroups;
};
